export default [
  {
    path: "*", // 页面不存在的情况下会跳到404页面
    redirect: "/newsindex",
    name: "notFound",
  },
  {
    path: "/set",
    component: () => import("@/views/Set"),
    children: [
      {
        path: "",
        name: "setindex",
        component: () => import("@/views/Set/Base"),
      },
      {
        path: "/changeSafe",
        name: "changeSafe",
        component: () => import("@/views/Set/ChangeSafe"),
      },
      {
        path: "/paypassword",
        name: "paypassword",
        component: () => import("@/views/Set/PayPassword"),
      },
      {
        path: "/changephone",
        name: "changephone",
        component: () => import("@/views/Set/ChangePhone"),
      },
      {
        path: "/selfsafe",
        name: "selfsafe",
        component: () => import("@/views/Set/Selfsage"),
      },
      {
        path: "/password",
        name: "password",
        component: () => import("@/views/Set/Password"),
      },
      {
        path: "/selfdata",
        name: "selfdata",
        component: () => import("@/views/Set/SelfData"),
      },
      {
        path: "/question",
        name: "question",
        component: () => import("@/views/Set/Question"),
      },
      {
        path: "/feedback",
        name: "feedback",
        component: () => import("@/views/Set/Feedback"),
      },
      {
        path: "/blacklist",
        name: "blacklist",
        component: () => import("@/views/Set/BlackList"),
      },
    ],
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/Login"),
  },

  {
    path: "/newsindex",
    name: "nest",
    component: () => import("@/views/NewIndex"),
    redirect: "/indexrecommend",
    children: [
      {
        path: "/indexrecommend",
        name: "indexrecommend",
        component: () => import("@/views/indexRecommend"),
      },
      {
        path: "/indexgoing",
        name: "indexgoing",
        component: () => import("@/views/indexGoing"),
      },
    ],
  },
  {
    path: "/book",
    name: "/book",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/book"),
  },
  {
    path: "/home",
    name: "home",

    component: () => import("@/views/Home"),
  },
  {
    path: "/excellentCourseList",
    name: "excellentCourseList",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/ExcellentCourseList"),
  },
  {
    path: "/readpackage",
    name: "readpackage",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Readpackage"),
  },
  {
    path: "/excellentcourseType",
    name: "excellentcourseType",

    component: () => import("@/views/ExcellentType"),
  },
  {
    path: "/rechange",
    name: "rechange",
    component: () => import("@/views/Rechange"),
  },
  {
    path: "/income",
    name: "income",
    component: () => import("@/views/Income"),
  },
  {
    path: "/draw",
    name: "draw",
    component: () => import("@/views/Draw"),
  },
  {
    path: "/drawlist",
    name: "drawlist",
    component: () => import("@/views/DrawList"),
  },
  {
    path: "/incomedetail",
    name: "incomedetail",
    component: () => import("@/views/IncomeDetail"),
  },
  {
    path: "/excellentCourse",
    name: "excellentCourse",
    component: () => import("@/views/ExcellentCourse"),
  },
  {
    path: "/course",
    name: "course",
    component: () => import("@/views/Course"),
  },
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: () => import("@/views/CourseDetail"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search"),
  },
  {
    path: "/me",
    name: "me",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Me"),
  },
  {
    path: "/attention",
    name: "attention",
    component: () => import("@/views/Attention"),
  },
  {
    path: "/fans",
    name: "fans",
    component: () => import("@/views/Fans"),
  },
  // {
  //   path: "/personalcenter1",
  //   name: "personalcente1",
  //   component: () => import("@/views/PersonalCenter")
  // },
  {
    path: "/masterinfo",
    name: "masterinfo",
    component: () => import("@/views/MasterInfo"),
  },
  {
    path: "/personalcenter",
    name: "personalcenter",
    component: () => import("@/views/PersonalCenter"),
  },
  {
    path: "/integral",
    name: "integral",
    component: () => import("@/views/Integral"),
  },
  {
    path: "/collect",
    name: "collect",
    component: () => import("@/views/Collect"),
  },

  {
    path: "/buylist",
    name: "buylist",
    component: () => import("@/views/BuyList"),
  },
  {
    path: "/commitdetail",
    name: "commitdetail",
    component: () => import("@/views/CommitDetail"),
  },
  {
    path: "/noticelist",
    name: "noticelist",
    component: () => import("@/views/NoticeList"),
  },
  {
    path: "/noticeinfo",
    name: "noticeinfo",
    component: () => import("@/views/NoticeInfo"),
  },
  {
    path: "/vipdetail",
    name: "vipdetail",
    component: () => import("@/views/VipDetail"),
  },
  {
    path: "/cardlist",
    name: "cardlist",
    component: () => import("@/views/CardList"),
  },
  {
    path: "/cardshare",
    name: "cardshare",
    component: () => import("@/views/CardSelect"),
  },
  {
    path: "/studylist",
    name: "stydylist",
    component: () => import("@/views/StudyList"),
  },
  {
    path: "/sign",
    name: "sign",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Sign"),
  },
  {
    path: "/updatabase",
    name: "updatabase",
    component: () => import("@/views/UpdataBase"),
  },

  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
  },

  {
    path: "/nestinfo",
    component: () => import("@/views/Formicary/NestInfo"),
    redirect: "/newsnew",
    children: [
      {
        path: "/newsnew",
        name: "newsnew",
        component: () => import("@/views/Formicary/NestInfo/Newsnew"),
      },
      {
        path: "/newszan",
        name: "newszan",
        component: () => import("@/views/Formicary/NestInfo/Newszan"),
      },
      {
        path: "/newsgood",
        name: "newsgood",
        component: () => import("@/views/Formicary/NestInfo/Newsgood"),
      },
    ],
  },
  {
    path: "/paynestinfo",
    name: "paynestinfo",
    component: () => import("@/views/Formicary/PayNestInfo"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/addrecommend",
    name: "addrecommend",
    component: () => import("@/views/Formicary/AddRecommend"),
    // AddRecommend.vue
  },
  {
    path: "/commitinfo",
    name: "commitinfo",
    component: () => import("@/views/Formicary/CommitInfo"),
  },
  {
    path: "/paynest",
    name: "paynest",
    component: () => import("@/views/Formicary/PayNest"),
  },
  {
    path: "/addpublish",
    name: "addpublish",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Formicary/AddPublish"),
  },
  {
    path: "/updatanews",
    name: "updatanews",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Formicary/UpdataNews"),
  },

  {
    path: "/nestset",
    component: () => import("@/views/Set"),
    redirect: "/",
    children: [
      {
        path: "/",
        name: "setbase",
        component: () => import("@/views/Formicary/Set/Index"),
      },

      {
        path: "/noticeedit",
        name: "noticeedit",
        component: () => import("@/views/Formicary/Set/NoticeEditor"),
      },
      {
        path: "/nestsuperset",
        name: "nestsuperset",
        component: () => import("@/views/Formicary/Set/superset"),
      },
    ],
  },

  {
    path: "/nestsearch",
    name: "nestsearch",
    component: () => import("@/views/Formicary/NestSearch"),
  },
  {
    path: "/noticeindex",
    name: "noticeindex",
    component: () => import("@/views/Formicary/Notice/NoticeIndex"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/nestbox",
    name: "nestbox",
    component: () => import("@/views/Formicary/Nestbox"),
  },
  {
    path: "/complaint",
    name: "complaint",
    component: () => import("@/views/Formicary/Complaint"),
  },
  {
    path: "/newsearch",
    name: "newsearch",
    component: () => import("@/views/Formicary/NewSearch"),
  },
  {
    path: "/answerinfo",
    name: "answerinfo",
    component: () => import("@/views/Formicary/Answer"),
  },
  {
    path: "/quest",
    name: "quest",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Formicary/Quest"),
  },
  {
    path: "/paycommitinfo",
    name: "paycommitinfo",
    component: () => import("@/views/Formicary/Paycommitinfo"),
  },
  {
    path: "/nestprivacy",
    name: "nestprivacy",
    component: () => import("@/views/Doc/Nestprivacy"),
  },
  {
    path: "/addread",
    name: "addread",
    component: () => import("@/views/Doc/addRead"),
  },
  {
    path: "/menews",
    name: "menews",
    component: () => import("@/views/Formicary/MeNews"),
  },
  // 这是专栏列表页
  {
    path: "/masterlist",
    name: "masterlist",
    component: () => import("@/views/MasterList"),
  },
  /////////////////这是读书训练营阶段的项目-----------------------------------
  {
    path: "/camppay",
    name: "camppay",
    component: () => import("@/views/Camp/CampPay"),
  },
  {
    path: "/mecamp",
    name: "mecamp",
    component: () => import("@/views/MeCamp"),
  },
  {
    path: "/camplist",
    name: "camplist",
    component: () => import("@/views/Camp/CampList"),
  },
  {
    path: "/feepannel",
    name: "freepannel",
    component: () => import("@/views/Camp/Freepannel"),
  },
  {
    path: "/people",
    name: "people",
    component: () => import("@/views/Camp/People"),
  },
  {
    path: "/honor",
    name: "honor",
    component: () => import("@/views/Camp/Honor"),
  },
  {
    path: "/campedit",
    name: "campedit",
    component: () => import("@/views/Camp/CampEdit"),
  },
  {
    path: "/campindex",
    name: "campindex",
    component: () => import("@/views/Camp/CampIndex"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/messageset",
    name: "messageset",
    component: () => import("@/views/Camp/MessageSet"),
  },
  // 作业详情
  {
    path: "/workdetail",
    name: "workdetail",
    component: () => import("@/views/Camp/Workdetail.vue"),
  },
  // 这是作业详情转换为动态详情的的页面
  {
    path: "/campcommitinfo",
    name: "campcommitinfo",
    component: () => import("@/views/Camp/CampCommitinfo.vue"),
  },
  {
    path: "/workask",
    name: "workask",
    component: () => import("@/views/Camp/WorkAsk.vue"),
  },
  {
    path: "/dowork",
    name: "dowork",
    component: () => import("@/views/Camp/DoWork.vue"),
  },
  // 这是作业列表页面的
  {
    path: "/worklist",
    name: "worklist",
    component: () => import("@/views/Camp/Worklist"),
  },
  // 身份证上传
  {
    path: "/idupload",
    name: "idupload",
    component: () => import("@/views/IdIdentity/IdUpload"),
  },
  {
    path: "/idresult",
    name: "idresult",
    component: () => import("@/views/IdIdentity/idResult"),
  },
  { // 畅听包退款
    path: "/vipok",
    name: "vipok",
    component: () => import("@/views/viprefund"),
    meta: {
      keepAlive: true,
    },
  },
];
